/**
 * Sets the style of the element when it becomes visible if the `on-visible-style` attribute is specified.
 *
 * This component makes use of the IntersectionObserver API.
 * If the browser does not support this API, the style is set immediately.
 */

const ATTRIBUTE = "on-visible-style";

function setStyleFor(element: HTMLElement) {
  const style = element.getAttribute(ATTRIBUTE);

  if (style) {
    element.setAttribute("style", style);
  }
}

function initOnVisibleStyle() {
  const elements = document.querySelectorAll(`[${ATTRIBUTE}]`) as NodeListOf<HTMLElement>;
  if (elements.length == 0) {
    return;
  }

  if ("IntersectionObserver" in window) {
    const options = { threshold: 1.0 };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const element = entry.target as HTMLElement;

        observer.unobserve(element);
        setStyleFor(element);
      });
    }, options);

    elements.forEach((element) => {
      observer.observe(element);
    });
  } else {
    elements.forEach((element) => {
      setStyleFor(element);
    });
  }
}

document.addEventListener("DOMContentLoaded", initOnVisibleStyle);
